import { ImgHTMLAttributes } from 'react';

import { LinkingTypeEnum } from '../../dto/recs.dto';
import { HtmlElementContext, Nullable } from '../../types';

type Props = Nullable<Partial<Pick<ImgHTMLAttributes<never>, 'src' | 'className' | 'alt' | 'width' | 'height' | 'title'>> & {
  linkingType?: LinkingTypeEnum;
}>;

export const imgElement = (props: Props, context: HtmlElementContext): HTMLImageElement => {
  const element = context.dom.createElement('img');
  element.src = props.src ?? '';

  if (props.title) {
    element.title = props.title;
  }

  if (props.width) {
    element.width = props.width as number;
  }

  if (props.height) {
    element.height = props.height as number;
  }

  if (props.alt) {
    element.alt = props.alt;
  }

  element.className = props.className ?? '';

  return element;
}
